// 회원가입의 parm 값과 통일
import {
  FormFieldSchema,
  FormFieldType,
  TriggerCondition,
  TriggerType,
} from "@app/components/forms/types/schema";

import { PlatformType } from "@app/types/platform";

interface PlatformSchemaProps {
  platformType: PlatformType;
  shopList?: {
    shop_title: string;
    shop_no: string;
  }[];
}

export const PlatformSchema = ({
  platformType,
  shopList,
}: PlatformSchemaProps): FormFieldSchema[] => {
  const defaultSchema: FormFieldSchema[] = [
    {
      type: FormFieldType.Text,
      id: "platformType",
      label: "플랫폼 타입",
      behavior: {
        hidden: true,
      },
    },
    {
      type: FormFieldType.Text,
      id: "orgName",
      label: "쇼핑몰 상호명",
      placeholder: "쇼핑몰 상호명을 입력하세요.",
      behavior: {
        required: true,
      },
    },
    {
      type: FormFieldType.URL,
      id: "platformUrl",
      label: "쇼핑몰 URL",
      placeholder: "쇼핑몰 URL를 입력하세요.",
      behavior: {
        required: true,
      },
    },
    {
      type: FormFieldType.Text,
      id: "platformKeyMAKESHOP",
      label: "상점 키(ShopKey)",
      placeholder: "상점 키를 입력하세요.",
      description:
        '메이크샵 연동관리 페이지 > 오픈 API > 업체명 "쇼츠웍스" 검색 > 상점키 [보기]를 누르시고 상점키를 복사합니다. 복사한 상점키를 입력하세요.',
      behavior: {
        triggers: [
          {
            type: TriggerType.Show,
            field: "platformType",
            value: PlatformType.MAKESHOP,
            condition: TriggerCondition.Equal,
          },
        ],
      },
    },
    {
      type: FormFieldType.Text,
      id: "platformKeyFLEXG",
      label: "API 연동키",
      placeholder: "API 연동키를 입력하세요.",
      description: (
        <div className="flex flex-col">
          <a
            target="_blank"
            href="https://guide.shortsworks.io/7a05f081-1d61-4c76-8d6e-3a019f81d394"
            className="underline text-primary"
          >
            플렉스지 API 연동키 생성 가이드
          </a>
          <div className="text-sm">
            가이드를 확인하여 API키를 생성, 입력하세요.
          </div>
        </div>
      ),
      behavior: {
        triggers: [
          {
            type: TriggerType.Show,
            field: "platformType",
            value: PlatformType.FLEXG,
            condition: TriggerCondition.Equal,
          },
        ],
      },
    },
    {
      type: FormFieldType.Text,
      id: "platformId",
      label: "쇼핑몰 ID(운영자 ID)",
      placeholder: "쇼핑몰 ID를 입력하세요.",
      behavior: {
        triggers: [
          {
            type: TriggerType.Show,
            field: "platformType",
            value: PlatformType.MAKESHOP,
            condition: TriggerCondition.Equal,
          },
        ],
      },
    },
    {
      type: FormFieldType.Text,
      id: "platformName",
      label: "관리자 이름",
      placeholder: "비밀번호를 한번 더 입력하세요.",
      behavior: {
        required: true,
      },
    },
    {
      type: FormFieldType.Email,
      id: "email",
      label: "관리자 이메일",
      placeholder: "비밀번호를 한번 더 입력하세요.",
      behavior: {
        required: true,
      },
    },
    {
      type: FormFieldType.Text,
      id: "phone",
      label: "관리자 연락처",
      placeholder: "비밀번호를 한번 더 입력하세요.",
      behavior: {
        required: true,
      },
    },
  ];

  if (shopList) {
    defaultSchema.push({
      type: FormFieldType.MultiSelect,
      id: "shopNo",
      label: "쇼핑몰 번호",
      defaultValue: shopList[0].shop_no, // 첫 번째 쇼핑몰 번호를 기본값으로 설정
      placeholder: "쇼핑몰 번호",
      options: shopList.map((list) => ({
        label: list.shop_title,
        value: list.shop_no,
      })),
    });
  }

  return defaultSchema;
};
